/**
 * Карточка UI/UX Design.
 */

import Typewriter from "../Typewriter/Typewriter";
import ServiceCard from "../ServiceCard/ServiceCard";
import { SERVICE_UIUX } from "../../config/services";

function UiUxCard() {
    const copy = SERVICE_UIUX;

    return (
        <ServiceCard variant="code">
            <div className="code-card-bar">
                <div className="code-card-controls">
                    <span className="code-card-dot"></span>
                    <span className="code-card-dot"></span>
                    <span className="code-card-dot"></span>
                </div>
                <span className="code-card-title">index.js</span>
                <div className="code-card-status">
                    <span className="code-card-status-icon">●</span>
                    <span className="code-card-status-text">CODING</span>
                </div>
            </div>
            <div className="code-card-body">
                <div className="code-design-split">
                    <div className="code-design-preview">
                        <div className="design-canvas">
                            <div className="site-preview">
                                <div className="site-header">
                                    <span className="site-text site-text-header">Welcome</span>
                                </div>
                                <div className="site-hero">
                                    <span className="site-text site-text-hero">Design</span>
                                </div>
                                <div className="site-content">
                                    <div className="site-card"></div>
                                    <div className="site-card"></div>
                                </div>
                                <div className="site-footer"></div>
                            </div>
                        </div>
                    </div>
                    <div className="code-card-editor">
                        <div className="code-line code-line_1">
                            <span className="code-line-num">1</span>
                            <span className="code-typing">&lt;Header /&gt;</span>
                        </div>
                        <div className="code-line code-line_2">
                            <span className="code-line-num">2</span>
                            <span className="code-typing">&lt;Hero /&gt;</span>
                        </div>
                        <div className="code-line code-line_3">
                            <span className="code-line-num">3</span>
                            <span className="code-typing">&lt;Content /&gt;</span>
                        </div>
                        <div className="code-line code-line_4">
                            <span className="code-line-num">4</span>
                            <span className="code-typing">&lt;Footer /&gt;</span>
                        </div>
                        <div className="code-line code-line_5">
                            <span className="code-line-num">5</span>
                            <span className="code-typing">Welcome</span>
                        </div>
                        <div className="code-line code-line_6">
                            <span className="code-line-num">6</span>
                            <span className="code-typing">Design</span>
                            <span className="code-cursor-blink">|</span>
                        </div>
                    </div>
                </div>
                <h3 className="group-9__title group-9__title_code">
                    <Typewriter text={copy.title} speed={copy.titleSpeed} delay={copy.titleDelay} />
                </h3>
                <p className="group-9__text group-9__text_code">
                    <Typewriter text={copy.text} speed={copy.textSpeed} delay={copy.textDelay} />
                </p>
            </div>
        </ServiceCard>
    );
}

export default UiUxCard;
// components/ServiceCards/UiUxCard.js
